import { Component, Input, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'letters-counter',
  templateUrl: 'letters-counter.component.html',
  styleUrls: ['letters-counter.component.scss'],
})
export class LettersCounterComponent {
  @Input() maxLength: number;
  @Input() currentLength: number;

  get lengthExceeded(): boolean {
    return this.currentLength > this.maxLength;
  }

  get lettersLeft(): number {
    return this.maxLength - this.currentLength;
  }
}
